import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

import { FinnairBoundItem, FinnairPassengerItem } from '@fcom/dapi/api/models';
import { FinnairServiceItemWithUpsell } from '@fcom/dapi/interfaces';

import { FlightWithSeats, getSeatsByFlight } from '../../../../utils/services-summary.utils';

@Component({
  selector: 'fin-included-product-item-summary-seat',
  templateUrl: './included-product-item-summary-seat.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IncludedProductItemSummarySeatComponent implements OnInit, OnChanges {
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;
  @Input() bodyClass = 'font-body-2';
  @Input() showPendingServicesInTitles = false;
  protected flightsSeats: FlightWithSeats[] = [];

  ngOnChanges(): void {
    this.update();
  }

  ngOnInit(): void {
    this.update();
  }

  private update() {
    this.flightsSeats = getSeatsByFlight(this.passengers, this.bound, this.service, this.showPendingServicesInTitles);
  }
}
